export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-22.jpg'),
        title: 'スマート製造',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'スマート製造',
      description: `<p>15年にわたる計画と実行で、デジタルとインテリジェンスを融合した製造の実現を支援します。政策に沿って5G、AI、産業向けインターネットを活用し、研究開発、生産、サプライチェーン全体のデータ連携を実現します。</p>
<p>ここではデジタルツインにより製品開発周期を短縮し、スマートラインにより生産効率が33%以上向上、グリーン製造でエネルギー消費を大幅に削減し、柔軟な生産でカスタム要求に応えます。工場内のスマート巡回からサプライチェーンの協調、重要技術の研究開発やエコシステム構築まで、政策と技術で「ものづくり」から「賢いものづくり」への転換を支援します。</p>
<p>時代と共に歩み、政策と協働し、スマート製造の力で企業のバリューチェーン上位化を後押しします。</p>`
    },
    {
      title: '当社の強み',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-21.jpg')+`)"></span>
      <span class="list">
      <i></i>高い自動化レベルで生産効率を大幅向上。<br/>
      <i></i>データ駆動の意思決定で運用の精度向上。<br/>
      <i></i>生産工程の可視化によりリアルタイム監視と管理が可能。<br/>
      <i></i>設備の相互接続で柔軟な生産と迅速な対応を実現。<br/>
      <i></i>品質検査の自動化で不良率を低減。<br/>
      <i></i>エネルギー最適化でグリーン・低炭素生産を実現。<br/>
      <i></i>人的依存を低減し、運用の安定性を向上。<br/>
      </span>`
    }
  ]
}
